module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#women-home",
      toString: function () {
        return this.url;
      }
    }